import { useEffect, useState } from "react";

/* Test ou production, sans jamais hésiter.

   Deux versions complètes tournent côte à côte : la production (1000arts.ch) et la version
   de test (1000arts.netlify.app), chacune avec son serveur et sa base. Sur la version de
   test, un bandeau jaune « VERSION DE TEST » reste en haut de TOUTES les pages (site,
   console, apps) et l'onglet du navigateur commence par « TEST · ».

   Le site sait ce qu'il est à la compilation (SITE_TEST=true sur le site Netlify de test,
   voir netlify.toml) ; le serveur le dit lui-même (/api/environnement). S'ils ne disent pas
   la même chose, le site est branché sur le mauvais serveur : bandeau ROUGE, partout,
   jusqu'à ce que REACT_APP_BACKEND_URL soit corrigé dans Netlify.

   Le bandeau ne prend jamais les clics (pointer-events: none) : il ne gêne aucun bouton.
   Il ne s'imprime pas depuis la console (index.css) : il se posait sur l'en-tête des
   feuilles de présence et des listes. */
const SITE_DE_TEST = process.env.REACT_APP_SITE_TEST === "true";
const PREFIXE = "TEST · ";

const prefixerOnglet = () => {
  if (!document.title.startsWith(PREFIXE)) document.title = PREFIXE + document.title;
};

export function etatVersion(siteDeTest, serveur) {
  if (serveur === "production" && siteDeTest) {
    return { couleur: "rouge", texte: "ATTENTION : site de TEST branché sur le serveur de PRODUCTION" };
  }
  if (serveur === "test" && !siteDeTest) {
    return { couleur: "rouge", texte: "ATTENTION : ce site est branché sur le serveur de TEST" };
  }
  if (siteDeTest || serveur === "test") return { couleur: "jaune", texte: "VERSION DE TEST" };
  return null;
}

export default function BandeauVersion() {
  const [serveur, setServeur] = useState(null);

  useEffect(() => {
    let vivant = true;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/environnement`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (vivant && d && d.environnement) setServeur(d.environnement); })
      .catch(() => { /* serveur injoignable : on s'en tient à ce que le site sait de lui-même */ });
    return () => { vivant = false; };
  }, []);

  const etat = etatVersion(SITE_DE_TEST, serveur);
  const texte = etat ? etat.texte : "";

  // Chaque page pose son propre titre : on remet « TEST · » devant à chaque changement.
  useEffect(() => {
    if (!texte) return undefined;
    prefixerOnglet();
    const titre = document.querySelector("title");
    if (!titre || typeof MutationObserver === "undefined") return undefined;
    const observateur = new MutationObserver(prefixerOnglet);
    observateur.observe(titre, { childList: true, characterData: true, subtree: true });
    return () => observateur.disconnect();
  }, [texte]);

  useEffect(() => {
    if (texte.startsWith("ATTENTION")) console.error(`[1000 ARTS] ${texte}`);
  }, [texte]);

  if (!etat) return null;
  const fond = etat.couleur === "rouge" ? "#DC2626" : "#FACC15";
  const encre = etat.couleur === "rouge" ? "#FFFFFF" : "#1F2937";
  return (
    <div aria-hidden="true" className="bandeau-version" data-testid="bandeau-version" data-couleur={etat.couleur}
      style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 2147483000, pointerEvents: "none" }}>
      <div style={{ height: "calc(3px + env(safe-area-inset-top, 0px))", background: fond }} />
      <div style={{ display: "flex", justifyContent: "center" }}>
        <span style={{
          background: fond, color: encre, borderRadius: "0 0 8px 8px", padding: "2px 10px 3px",
          font: "700 10px/1.3 system-ui, -apple-system, sans-serif", letterSpacing: "0.08em",
          textTransform: "uppercase", boxShadow: "0 1px 3px rgba(0,0,0,.18)", maxWidth: "calc(100vw - 32px)",
          textAlign: "center",
        }}>
          {etat.texte}
        </span>
      </div>
    </div>
  );
}
